import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import { Provider } from "react-redux";
import configureStore from "./redux/store";
import ThemeModeProvider from "./common/ThemeModeContext";

import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";
import "assets/css/theme.css";

const hist = createBrowserHistory();

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render( 
  <Provider store={configureStore()}>
    <ThemeModeProvider>
      <Router history={hist}>
        <Switch>
          <Route path="/auth" component={AuthLayout} />
          <Route path="/admin" component={AdminLayout} />
          <Redirect from="/" to="/admin/dashboard" />
        </Switch>
      </Router>
    </ThemeModeProvider>
  </Provider>
);
